module.exports = "<select #combobox multiple class=\"chosen-select form-control\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/combobox/combobox.component.html
// module id = ./src/app/shared/components/combobox/combobox.component.html
// module chunks = main